import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';

const rowBreakpointClass = {
  lg: 'lg:!flex-row',
  xl: 'xl:!flex-row',
  none: '',
} as const;

export const VisContentsContainer = ({
  children,
  rowBreakpoint = 'lg',
}: {
  children: ReactNode;
  rowBreakpoint?: keyof typeof rowBreakpointClass;
}) => {
  const { pathname } = useLocation();
  const isPreview = pathname.includes('preview');

  return (
    <div className={twJoin('flex flex-col gap-2 flex-1', !isPreview && rowBreakpointClass[rowBreakpoint])}>
      {children}
    </div>
  );
};
